export default function isAuthorized({ auth, requires }) {
  const { permissions, roles } = auth;

  if (Array.isArray(requires)) {
    return requires.some((require) => permissions.includes(require) || roles.includes(require));
  }

  return (requires && permissions?.includes(requires)) || (requires && roles?.includes(requires));
}
